export default "__VITE_ASSET__aebc2a54__"